import { actionTypes, mutationTypes } from '@/types';

export default {
	state: {
		isOpened: false,
		mediaId: null,
	},
	mutations: {
		[mutationTypes.setZoomMediaId]: (state, id) => {
			state.mediaId = id;
		},
		[mutationTypes.setZoomIsOpened]: (state, bool) => {
			state.isOpened = bool;
		},
	},
	actions: {
		[actionTypes.openZoom]: ({ commit }, id) => {
			commit(mutationTypes.setZoomMediaId, id);
			commit(mutationTypes.setZoomIsOpened, true);
		},
		[actionTypes.closeZoom]: ({ commit }) => {
			commit(mutationTypes.setZoomMediaId, null);
			commit(mutationTypes.setZoomIsOpened, false);
		},
	},
	getters: {
		getZoomIsOpened: (state) => {
			return state.isOpened;
		},
		getZoomMediaId: (state) => {
			return state.mediaId;
		},
	},
};
